import subscriptionsGetStatistics from './actions/getStatistics';
import subscriptionsGetStatisticsGroups from './actions/getStatisticsGroups';

const actions = {
    subscriptionsGetStatistics,
    subscriptionsGetStatisticsGroups
};

const mutations = {};

const getters = {};

export default { actions, mutations, getters };
